import { task } from '@api/req';
import http from '@util/http';

/** 项目管理 */
// 项目列表
export async function queryProjList(params) {
  return http.get(task.PROJ_LIST, params);
}

// 我发起的项目列表
export async function queryProjLauList(params) {
  return http.get(task.PROJ_LAU_LIST, params);
}

// 我收到的项目列表
export async function queryProjReceiveList(params) {
  return http.get(task.PROJ_RECEIVE_LIST, params);
}

// 项目新增
export async function queryPostProjSave(params) {
  return http.post(task.PROJ_SAVE, params);
}

// 项目删除
export async function queryDeleteProj(params) {
  return http.get(task.PROJ_DELETE, params);
}

// 项目详情
export async function queryProjInfo(params) {
  return http.get(task.PROJ_INFO, params);
}

// 项目状态修改
export async function queryProjUpdStatus(params) {
  return http.post(task.PROJ_UPD_STATUS, params);
}

// 项目任务列表
export async function queryProjTaskList(params) {
  return http.get(task.PROJ_TASK_LIST, params);
}

// 项目文件列表
export async function queryProjFilesList(params) {
  return http.get(task.PROJ_FILES_LIST, params);
}

// 项目文件保存
export async function querySaveProjFiles(params) {
  return http.post(task.PROJ_FILES_SAVE, params);
}

// 项目文件删除
export async function queryDeleteProjFiles(params) {
  return http.get(task.PROJ_FILES_DELETE, params);
}

// 任务完成率统计
export async function queryProjStatRate(params) {
  return http.get(task.PROJ_STAT_RATE, params);
}

/** 项目目录管理 */
// 项目目录列表
export async function queryProjDirList(params) {
  return http.get(task.PROJ_DIR_LIST, params);
}

// 项目目录详情
export async function queryProjDirInfo(params) {
  return http.get(task.PROJ_DIR_INFO, params);
}

// 项目目录保存
export async function querySaveProjDir(params) {
  return http.post(task.PROJ_DIR_SAVE, params);
}

// 项目目录删除
export async function queryDeleteProjDir(params) {
  return http.get(task.PROJ_DIR_DEL, params);
}

/** 任务管理 */
// 任务监控
export async function queryTaskList(params) {
  return http.get(task.TASK_LIST, params);
}

// 任务高级搜索
export async function queryTaskSearch(params) {
  return http.get(task.TASK_SEARCH, params);
}

// 我发起的任务列表
export async function queryTaskLauList(params) {
  return http.get(task.TASK_LAU_LIST, params);
}

// 我收到的任务列表
export async function queryTaskReceiveList(params) {
  return http.get(task.TASK_RECEIVE_LIST, params);
}

// 我收到的任务列表高级搜索
export async function queryTaskSearchList(params) {
  return http.get(task.TASK_SEARCH_LIST, params);
}

// 待审核的任务列表监控
export async function queryTaskCheckList(params) {
  return http.get(task.TASK_CHECK_LIST, params);
}

// 我的待审核的任务列表
export async function queryTaskCheckMy(params) {
  return http.get(task.TASK_CHECK_MY, params);
}

// 任务新增
export async function querySaveTask(params) {
  return http.post(task.TASK_SAVE, params);
}

// 任务删除
export async function queryDeleteTask(params) {
  return http.get(task.TASK_DELETE, params);
}

// 任务收藏
export async function querySetTaskCollect(params) {
  return http.get(task.TASK_COLLECT, params);
}

// 任务取消收藏
export async function querySetTaskUnCollect(params) {
  return http.get(task.TASK_UNCOLLECT, params);
}

// 任务详情
export async function queryTaskInfo(params) {
  return http.get(task.TASK_INFO, params);
}

// 任务附件
export async function queryTaskFiles(params) {
  return http.get(task.TASK_FILES, params);
}

// 任务日志
export async function queryTaskLog(params) {
  return http.get(task.TASK_LOG, params);
}

// 任务完成
export async function queryTaskCompletion(params) {
  return http.post(task.TASK_COMPLETION, params);
}

// 任务废弃
export async function queryTaskDiscard(params) {
  return http.get(task.TASK_DISCARD, params);
}

/** 任务审核流程 */
export async function queryNextTaskCheck(params) {
  return http.get(task.TASKCHECK_NEXT, params);
}

export async function queryReturnTaskCheck(params) {
  return http.post(task.TASKCHECK_RETURN, params);
}

export async function queryCallbackTaskCheck(params) {
  return http.get(task.TASKCHECK_CALLBACK, params);
}

export async function queryTaskCheckWorkflow(params) {
  return http.get(task.TASKCHECK_WORKFLOW, params);
}

/** 标签管理 */
// 标签列表
export async function queryTagList(params) {
  return http.get(task.TAG_LIST, params);
}

// 标签删除
export async function queryTagDel(params) {
  return http.get(task.TAG_DEL, params);
}

// 标签关联删除
export async function queryTagRelateDel(params) {
  return http.get(task.TAG_RELATE_DEL, params);
}



// WEBPACK FOOTER //
// ./src/api/task.js